__turbopack_context__.v({
  "className": "mona_sans_c38570fd-module__xWbhAW__className",
});
